export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20technology%20landscape%2C%20warm%20amber%20golden%20flowing%20waves%20of%20light%2C%20geometric%20data%20visualization%20patterns%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%20atmosphere%2C%20digital%20transformation%20aesthetic%2C%20professional%20yet%20artistic%20feel%2C%20luxurious%20dark%20background%20with%20golden%20accents&width=1600&height=900&seq=mrds-hero-bg&orientation=landscape"
          alt="mrds 官方平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6 text-center">
        <div className="max-w-[720px]">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-background-50/90 text-sm font-medium">mrds V3.0 全新发布</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            让专业更<strong className="text-primary-300">简单</strong>，
            <br className="hidden sm:block" />
            让效率更<strong className="text-primary-300">卓越</strong>
          </h1>
          <p className="text-background-50/75 text-base md:text-lg leading-relaxed mb-8 max-w-[560px] mx-auto">
            mrds 是您值得信赖的专业平台，提供智能数据处理、自动化工作流和实时协作等一站式解决方案，助力您的业务实现高效增长。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              免费开始使用
            </Link>
            <a
              href="/categories"
              className="px-8 py-3 bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/20 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center pt-2">
          <span className="w-1 h-2 rounded-full bg-background-50/50 animate-bounce"></span>
        </div>
      </div>
    </section>
  );
}